import apiHelper from '../helpers/apiHelper'

export default {
  get()
  {
    return apiHelper.request('loan/list')
  },
  getLoansPage(page, filters, minInvestment, searchPhrase, sortBy = null, sortDir = 'desc')
  {
    const data = {}

    if (sortBy && sortDir)
    {
      data.sort = sortBy
      data.sort_dir = sortDir
    }

    if (filters || searchPhrase)
    {
      data.filters = filters
      if (minInvestment && minInvestment !== '')
      {
        data.minimum_investment = minInvestment
      }
      data.search = searchPhrase
    }
    return apiHelper.request('loan/list/' + parseInt(page), data, 'POST')
    // return apiHelper.request('loan/list/' + parseInt(page))
  },
  getLoansCountAfterFilters(filters, minInvestment)
  {
    const data = {filters: filters}
    if (minInvestment && minInvestment !== '')
    {
      data.minimum_investment = minInvestment
    }
    return apiHelper.request('loan/countAfterFilters', data, 'POST')
  },
  getDetails(id)
  {
    return apiHelper.request('loan/details/' + id)
  },
  getMoreDetails(id)
  {
    return apiHelper.request('loan/more-details/' + id)
  }
}
